var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23193 10.7386V22.2999C2.23193 26.9786 6.05993 30.7679 10.7386 30.8066H22.2999C26.9786 30.8066 30.7679 26.9786 30.8066 22.2999V10.7386C30.8066 6.05993 26.9786 2.2706 22.2999 2.23193H10.7386C6.05993 2.23193 2.23193 6.05993 2.23193 10.7386ZM10.7386 3.23727H22.2999C26.4373 3.23727 29.8013 6.60127 29.8013 10.7386V22.2999C29.8013 26.4373 26.4373 29.8013 22.2999 29.8013H10.7386C6.60127 29.8013 3.23727 26.4373 3.23727 22.2999V10.7386C3.23727 6.60127 6.60127 3.23727 10.7386 3.23727Z",
    fill: "#0079C1",
    stroke: "#0079C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54004 16.5001C9.54004 20.3281 12.672 23.4601 16.5 23.4601C20.328 23.4601 23.46 20.3281 23.46 16.5001C23.46 14.6441 22.7254 12.9041 21.4107 11.5894C20.096 10.2747 18.356 9.54008 16.5 9.54008C12.672 9.54008 9.54004 12.6721 9.54004 16.5001ZM16.5 10.6614C19.7094 10.6614 22.3387 13.2907 22.3387 16.5001C22.3387 19.7094 19.7094 22.3387 16.5 22.3387H16.3067C13.1747 22.2227 10.6614 19.6707 10.6614 16.5001C10.6614 13.2907 13.2907 10.6614 16.5 10.6614ZM24.852 6.56274C24.0014 6.56274 23.2667 7.25874 23.2667 8.14808C23.2667 9.03741 23.9627 9.73341 24.852 9.73341C25.7414 9.73341 26.4374 9.03741 26.4374 8.14808C26.4374 7.25874 25.7414 6.56274 24.852 6.56274Z",
    fill: "#0079C1",
    stroke: "#0079C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.60bc15055dc9801247578e3a5df7341b.svg";
export { ForwardRef as ReactComponent };